// src/pages/StripeAccountSignUp.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_BASE = "https://9gyb2coj2i.execute-api.eu-west-2.amazonaws.com/dev";
const ROUTE = "/create-stripe-connect-onboarding-link";

export default function StripeAccountSignUp() {
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { getIdToken } = useAuth();

  useEffect(() => {
    const go = async () => {
      try {
        const idToken = await getIdToken();

        const res = await fetch(`${API_BASE}${ROUTE}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        });

        if (res.status === 401) {
          setErr("Session expired. Please log in again.");
          setLoading(false);
          return;
        }

        if (res.status === 403) {
          setErr("Only photographers can set up payouts.");
          setLoading(false);
          return;
        }

        if (!res.ok) {
          const txt = await res.text();
          throw new Error(txt || "Failed to start onboarding");
        }

        const data = await res.json();

        if (data?.url) {
          window.location.href = data.url;
          return;
        }

        throw new Error("No onboarding URL returned");
      } catch (e) {
        console.error("[StripeAccountSignUp] onboarding error:", e);
        setErr(e.message || "Something went wrong");
        setLoading(false);
      }
    };

    go();
  }, [getIdToken]);

  if (loading) {
    return <p>Redirecting you to Stripe to complete payouts setup…</p>;
  }

  return (
    <div>
      <h1>Stripe Onboarding</h1>
      <p>Something went wrong: {err}</p>
      <button onClick={() => navigate("/")}>Back to Home</button>
      <button onClick={() => window.location.reload()} style={{ marginLeft: 8 }}>
        Try Again
      </button>
    </div>
  );
}